"use client";

import { useState } from "react";
import { isEditorialPlayback } from "@/lib/video/contracts";

export default function PublicationVideoPlayer({ video, publicationId }) {
  const [failedSource, setFailedSource] = useState(null);
  if (!isEditorialPlayback(video, publicationId)) return null;
  const failed = failedSource === video.source.src;
  return <div className="publication-video-player" data-video-id={video.id} style={{ width: "100%", aspectRatio: "16 / 9", background: "#121111", color: "white" }}>
    {failed ? <div role="status" className="publication-video-error">This video is currently unavailable. Please try again later.</div>
      : <video key={video.source.src} controls playsInline preload="none" poster={video.poster || undefined}
        style={{ width: "100%", height: "100%", objectFit: "cover" }} aria-label={video.title} onError={() => setFailedSource(video.source.src)}>
        <source src={video.source.src} type={video.source.type} />
        Your browser does not support video playback.
      </video>}
  </div>;
}
